import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class AttributesService {

  attribute_form = new FormGroup({
    id : new FormControl(null),
    attribute_name : new FormControl(),
    parent_attribute : new FormControl(),
    slug : new FormControl(),
    description : new FormControl(),
  });

  constructor() { }
}
